import { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

import ThinArrowIcon from "./icon/ThinArrowIcon";

export interface ChevronProps extends SvgIconProps {
  direction?: "forward" | "back" | "down" | "up";
}

export const Chevron: React.FC<ChevronProps> = ({ direction = "forward", style, ...props }) => {
  const rotation = { forward: 0, back: 180, down: 90, up: -90 }[direction];
  return (
    <ThinArrowIcon {...props} style={{ fontSize: 20, flexShrink: 0, transform: `rotate(${rotation}deg)`, ...style }} />
  );
};
